import { createAsyncThunk } from '@reduxjs/toolkit';
import { campaignService } from '../../services';

const getAllCampaigns = createAsyncThunk(
    'campaigns/getAllCampaigns',
    async (payload, thunkAPI) => {
        try {
            const response = await campaignService.getAllCampaigns(payload.companyId);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCampaignDetails = createAsyncThunk(
  'campaigns/getCampaignDetails',
  async (payload, thunkAPI) => {
      try {
          const response = await campaignService.getCampaignDetails(payload.companyId, payload.campaignId);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const updateCampaign = createAsyncThunk(
  'campaigns/updateCampaign',
  async (payload, thunkAPI) => {
    try {
      const response = await campaignService.updateCampaign(payload.companyId, payload.campaignId, payload.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const deleteCampaign = createAsyncThunk(
  'campaigns/deleteCampaign',
  async (payload, thunkAPI) => {
    try {
      const response = await campaignService.deleteCampaign(payload.companyId, payload.campaignId);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const createCampaign = createAsyncThunk(
  'campaigns/createCampaign',
  async (payload, thunkAPI) => {
    try {
      const response = await campaignService.createCampaign(payload.companyId, payload.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const deleteCampaigns = createAsyncThunk(
  'campaigns/deleteCampaigns',
  async (payload, thunkAPI) => {
    try {
      const response = await campaignService.deleteCampaigns(payload.companyId, payload.campaignIds);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const uploadImage = createAsyncThunk(
  'campaigns/uploadImage',
  async (payload, thunkAPI) => {
    try {
      const response = await campaignService.uploadImage(payload.companyId, payload.campaignId, payload.image);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const deleteImage = createAsyncThunk(
  'campaigns/deleteImage',
  async (payload, thunkAPI) => {
    try {
      const response = await campaignService.deleteImage(payload.companyId, payload.campaignId, payload.imageId);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const getCampaignTriggers = createAsyncThunk(
  'campaigns/getCampaignTriggers',
  async (payload, thunkAPI) => {
      try {
          const response = await campaignService.campaignTriggers(payload.companyId);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const getSelectedCampaignPartners = createAsyncThunk(
  'campaigns/getSelectedCampaignPartners',
  async (payload, thunkAPI) => {
      try {
          const response = await campaignService.selectedCampaignPartners(payload.companyId);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const getSelectedCampaignChannels = createAsyncThunk(
  'campaigns/getSelectedCampaignChannels',
  async (payload, thunkAPI) => {
      try {
          const response = await campaignService.selectedCampaignChannels(payload.companyId);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const getCampaignIngestion = createAsyncThunk(
  'campaigns/getCampaignIngestion',
  async (payload, thunkAPI) => {
      try {
          const response = await campaignService.campaignIngestion(payload.companyId);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const updateCampaigningestion = createAsyncThunk(
  'campaigns/updateCampaigningestion',
  async (payload, thunkAPI) => {
      try {
          const response = await campaignService.updateCampaigningestion(payload.companyId, payload.selected);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const updateCampaignGeneration = createAsyncThunk(
  'campaigns/updateCampaignGeneration',
  async (payload, thunkAPI) => {
      try {
          const response = await campaignService.updateCampaignGeneration(payload.companyId, payload.selected);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const updateCampaignDeduplication = createAsyncThunk(
  'campaigns/updateCampaignDeduplication',
  async (payload, thunkAPI) => {
      try {
          const response = await campaignService.updateCampaignDeduplication(payload.companyId, payload.campaignId, payload.deduplication);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const getCount= createAsyncThunk(
  'campaigns/getCount',
  async (payload, thunkAPI) => {
      try {
          const response = await campaignService.getCount(payload.companyId, payload.campaignId);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const getCampaignSummary= createAsyncThunk(
  'campaigns/getCampaignSummary',
  async (payload, thunkAPI) => {
      try {
          const response = await campaignService.getCampaignSummary(payload.companyId, payload.campaignId);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);


export {
    getAllCampaigns,
    getCampaignDetails,
    createCampaign,
    deleteCampaign,
    updateCampaign,
    deleteCampaigns,
    uploadImage,
    deleteImage,
    getCampaignTriggers,
    getSelectedCampaignPartners,
    getSelectedCampaignChannels,
    getCampaignIngestion,
    updateCampaigningestion,
    updateCampaignGeneration,
    updateCampaignDeduplication,
    getCount,
    getCampaignSummary
}